export default "__VITE_ASSET__daee765f__"